/**
 * QueryClient configuration for React Query
 *
 * WP-AUTH-REFRESH-DEDUP-1: Exported for use by refreshCoordinator.ts
 * to pause queries during token refresh operations.
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: (failureCount, error) => {
        if (error instanceof Error && 'status' in error) {
          const status = (error as { status: number }).status;
          // Never retry auth or rate limit errors
          if (status === 401 || status === 403 || status === 429) {
            return false;
          }
          // Only retry server errors once
          if (status >= 500 && failureCount >= 1) {
            return false;
          }
        }
        return failureCount < 2;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
});
